import React from "react";
import { useSelector } from "react-redux";
import { CircularProgress } from "@mui/material";

import { CalendarBox, HeaderBar, MessagesList, RangeCalendar } from "components";
import { getIsMaximized, getIsMobileWindow, getIsParentView, getVisibleCalendar, getVisibleRangeCalendar, selectMascotSettings } from "slices";

const ChatbotContent = ({ parentWindowHeight, position, parentWindowWidth, shouldShowContent }) => {
  const visibleCalendar = useSelector(getVisibleCalendar);
  const visibleRangeCalendar = useSelector(getVisibleRangeCalendar);
  const isMaximized = useSelector(getIsMaximized);
  const isParentView = useSelector(getIsParentView);
  const mascotSettings = useSelector(selectMascotSettings);
  const isMobile = useSelector(getIsMobileWindow);

  return (
    <div
      id="chatbot-content"
      className={`${isParentView ? "hayley-relative hayley-flex hayley-items-center hayley-justify-center" : ""} ${
        isMaximized && "hayley-relative hayley-h-full hayley-w-full hayley-items-center hayley-justify-center hayley-bg-secondary/80 sm:hayley-p-[30px]"
      }`}
    >
      <div
        className={`hayley-relative hayley-flex hayley-flex-col hayley-overflow-hidden  hayley-bg-white hayley-font-opensans hayley-shadow ${
          parentWindowWidth < 768 && !isMaximized ? "hayley-h-[calc(100dvh-2px)]" : ""
        } ${isParentView && !isMaximized ? "hayley-h-full hayley-w-full md:hayley-h-[720px] md:hayley-w-[500px]" : ""} ${
          isMaximized ? "hayley-relative hayley-h-full hayley-w-full hayley-bg-white" : ""
        }`}
        style={
          parentWindowWidth >= 768 && !isMaximized
            ? {
                height: parentWindowHeight ? `${Math.min(parentWindowHeight - 60, 720)}px` : "720px",
                width: "500px",
              }
            : undefined
        }
      >
        <HeaderBar />
        {shouldShowContent ? (
          <>
            <MessagesList mascotSettings={mascotSettings} position={position} isMobile={isMobile} />
            {visibleCalendar && <CalendarBox />}
            {visibleRangeCalendar && (
              <div className="hayley-absolute hayley-bottom-0 hayley-top-0 hayley-z-30 hayley-flex hayley-h-full hayley-w-full hayley-items-center hayley-justify-center hayley-bg-custom-6/70">
                <RangeCalendar />
              </div>
            )}
          </>
        ) : (
          <div className="hayley-flex hayley-h-full hayley-items-center hayley-justify-center">
            <CircularProgress />
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatbotContent;
